package fr.frux.core.ads

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

actual fun createAdsPlatform(): AdsPlatform = NoAdsPlatform

actual fun adsConfig(): AdsConfig = AdsConfig.DISABLED

@Composable
internal actual fun rememberPlatformBannerLoaded(): Boolean = false

@Composable
internal actual fun PlatformBannerAd(modifier: Modifier) = Unit

@Composable
internal actual fun rememberPlatformNativeReady(active: Boolean): Boolean = false

@Composable
internal actual fun PlatformNativeAd(modifier: Modifier) = Unit
